module.exports = __webpack_public_path__ + "img/team8.5510e469.jpg";